export default __webpack_public_path__ + "static/media/intro_image.aa94f573.png";